/**
 * Copyright © 2026 Delicious AI, LLC
 */

import { gql } from '@apollo/client'

export const RELEASE_IMAGE_LEASE = gql`
  mutation ReleaseImageLease($imageId: ID!) {
    releaseImageLease(imageId: $imageId) {
      success
    }
  }
`
